import React from "react"
import logo from "./logo.svg"

export default function Logo() {
  return (
    <img src={logo} alt="BSSR Logo" className="w-10 xl:w-16 mr-2 lg:mr-4" />
  )
}
